import { IconBounceRight } from '@tabler/icons-react';
import { Popover, Transition } from '@headlessui/react';
import { useCallback } from 'react';
import PlayerMenuTooltip from '../PlayerMenuTooltip';
import { TransitionPopup } from './TransitionPopup';
import { ImageElement } from '@/player-config/src/types/RemotionPlayerConfigTypes/Element/ImageElement';
import { VideoElement } from '@/player-config/src/types/RemotionPlayerConfigTypes/Element/VideoElement';
import { classnames } from '@/libs/utils';
import useAnalytics from '@/hooks/useAnalytics';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

export const ElementTransitionButton = ({ selectedElement }: { selectedElement: ImageElement | VideoElement }) => {
  const { trackTransitionButtonClicked } = useAnalytics();
  const { clipId } = useClipsContext();

  const onClick = useCallback(() => {
    trackTransitionButtonClicked({ clipId, assetType: selectedElement.type });
  }, [clipId, selectedElement.type, trackTransitionButtonClicked]);
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            onClick={onClick}
            data-testid="image-element-remove-button"
            className={classnames(
              'group/button flex size-10 items-center justify-center rounded-md',
              open ? 'bg-slate-100' : 'hover:bg-slate-100'
            )}
          >
            <IconBounceRight size={20} />
            <PlayerMenuTooltip content="Transition" />
          </Popover.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Popover.Panel>
              <TransitionPopup selectedElement={selectedElement} />
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};
